module.exports = {
  fromGain: require('./from-gain'),
  toGain: require('./to-gain')
}